import { TenorLimits } from './tenorLimits';

export enum PositionLimitRequestStatus {
  OPEN = 'OPEN',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum PositionLimitStatus {
  OPEN = 'OPEN',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ACTIVE = 'ACTIVE',
  AMENDED = 'AMENDED',
  EXPIRED = 'EXPIRED',
}

export interface PositionLimitsData {
  partnerId: string;
  clientId: string;

  notionalLimitSpots: number;
  notionalLimitForwards: number;
  notionalLimitOptions: number;
  notionalLimitTotal: number;
  tenorLimitForwards: TenorLimits;
  tenorLimitOptions: TenorLimits;

  spotsIm: boolean;
  currency: string;
}

export interface PositionLimitsProfileRequest extends PositionLimitsData {
  id: string;

  status: PositionLimitRequestStatus;
  reason: string;
}

export interface PositionLimitsProfile extends PositionLimitsData {
  request: PositionLimitsData;

  expirationDate: string;
  amendmentReason: string;

  createdAt: string;
  createdBy: string;
  amendedAt: string;
  amendedBy: string;
}

export interface PositionUsageReport {
  notionalLimitSpots: number;
  notionalLimitSpotsInUse: number;
  notionalLimitSpotsUsage: number;
  notionalLimitForwards: number;
  notionalLimitForwardsInUse: number;
  notionalLimitForwardsUsage: number;
  notionalLimitOptions: number;
  notionalLimitOptionsInUse: number;
  notionalLimitOptionsUsage: number;
  notionalLimitTotal: number;
  notionalLimitTotalInUse: number;
  notionalLimitTotalUsage: number;

  currency: string;
}

export interface ClientPositionUsageReport extends PositionUsageReport {
  clientId: string;
  clientName: string;
  partnerId: string;
  partnerName: string;
}

export interface PositionLimitAudit {
  id: string;
  clientId: string;
  partnerId: string;

  currency: string;

  notionalLimitForwards: number;
  notionalLimitOptions: number;
  notionalLimitSpots: number;
  notionalLimitTotal: number;

  profile: PositionLimitsProfile;
  request: PositionLimitsProfileRequest;

  status: PositionLimitStatus;
}

export interface PositionLimitFilters {
  partnerName?: string;
  clientName?: string;
  clientType?: string;
  countryCode?: string;
  query?: string;
  status?: PositionLimitStatus;
  currency?: string;
  spotsIm?: boolean;
}
